/* Scroll-reveal for custom community sections.
   Ref: tittan13toy-templates/script.js (revealIn system) — same timing,
   stagger and reduced-motion behavior. Elements opt in via [data-cc-reveal];
   classes are added by JS so content stays visible without JavaScript. */
(function () {
  'use strict';

  function init() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var els = document.querySelectorAll('[data-cc-reveal]:not(.cc-reveal):not(.cc-revealed)');
    if (!els.length) return;

    Array.prototype.forEach.call(els, function (el) {
      el.classList.add('cc-reveal');
      var parent = el.parentElement;
      if (parent) {
        var sibs = Array.prototype.filter.call(parent.children, function (c) {
          return c.classList && c.classList.contains('cc-reveal');
        });
        var idx = sibs.indexOf(el);
        if (idx > 0) el.style.setProperty('--cc-reveal-delay', String(Math.min(idx, 5)));
      }
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cc-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    Array.prototype.forEach.call(els, function (el) {
      io.observe(el);
      el.addEventListener('animationend', function (e) {
        if (e.animationName === 'ccRevealIn') {
          el.classList.remove('cc-reveal', 'cc-revealed');
          el.style.removeProperty('--cc-reveal-delay');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
